import React from 'react'

import Base from '../_Base'

const ArrowRight = (props) => (
  <Base width="24" height="24" viewBox="0 0 24 24" {...props}>
    <path d="M5,11 L16.17,11 L11.2875044,6.11750442 C10.8981388,5.7281388 10.8981388,5.0968524 11.2875044,4.70748678 L11.29,4.705 L11.292902,4.7021184 C11.683825,4.31394844 12.3150637,4.3150637 12.7046126,4.70461259 L19.2928932,11.2928932 C19.6834175,11.6834175 19.6834175,12.3165825 19.2928932,12.7071068 L12.705,19.295 C12.3156393,19.6843607 11.6843607,19.6843607 11.295,19.295 C10.9055372,18.9055372 10.9052546,18.2741804 11.2943686,17.8843691 L16.17,13 L5,13 C4.44771525,13 4,12.5522847 4,12 C4,11.4477153 4.44771525,11 5,11 Z" />
  </Base>
)

export default ArrowRight
